





























































































import { defineComponent, reactive, toRefs, onMounted, onUnmounted, computed, ref } from '@vue/composition-api'
import CompHeader from '@/layout/Header.vue'
import UserInfo from './_components/UserInfo.vue'
import HomeTab from '@/components/HomeTab.vue'
import Interests from '@/components/Interests.vue'
import ToTop from '@/components/common/ToTop.vue'
import PdfCommonPayModule from '@/components/common/PdfCommonPayModule.vue'
import NewInterests from '@/components/NewInterests.vue'

import { useReflectiveInjector } from '@zhfe/vue2-di-plugin'
import { TranslateService } from './translate.service'
import { UserService } from '@/services/user.service'
import client from '@/client/'
import { STAY_PAGE_NUM } from '@/config/dataMap'

export default defineComponent({
  name: 'translate',
  components: {
    CompHeader,
    UserInfo,
    HomeTab,
    Interests,
    ToTop,
    PdfCommonPayModule,
    NewInterests,
  },
  setup (props, context) {
    const injector = useReflectiveInjector([TranslateService])
    const service = injector.get(TranslateService)
    const user = injector.get(UserService)

    const payModule = ref(null)
    const viewModel = reactive({
      tabs: [
        {
          text: '会员-全文翻译',
          icon: require('@/assets/images/pdf-icon.png'),
          active_icon: require('@/assets/images/pdf-icon-active.png'),
          report_id: 51,
        },
        {
          text: '加量购买翻译页数',
          icon: require('./_images/translate-icon.png'),
          active_icon: require('./_images/translate-icon-active.png'),
          report_id: 52,
        },
      ],
      curTab: 0,
      pdfSetingShow: [154],
      translateSetingShow: [155],
      isVip: service.isVip, // 是否极光PDF会员
      interestOptions: {},
      hasTranslateQrcode: false, // 全文翻译支付二维码展示
      isPdfLifeMember: user.isPdfLifeMember,
      isMember: user.isMember, // 是否毒霸联合会员
    })

    const subUserInfoChanged = user.onUserInfoChanged.subscribe(() => {
      viewModel.isVip = service.isVip
      viewModel.isPdfLifeMember = user.isPdfLifeMember
    })

    onMounted(() => {
      init()
      // 关闭前上报停留时间
      window.onbeforeunload = () => {
        // @ts-ignore
        const stay_time = parseInt((new Date().getTime() - performance.timing.fetchStart))
        // @ts-ignore
        stayTimeReport({ click: 7, stay_time })
        // @ts-ignore
        localStorage.setItem('translate-home-stay-time', stay_time)
      }
    })

    onUnmounted(() => {
      subUserInfoChanged.unsubscribe()
    })

    const isPdfTab = computed(() => viewModel.curTab === 0)

    // 是否是会员
    const isMemberShip = computed(() => viewModel.isVip || viewModel.isMember)

    function init () {
      if (viewModel.isVip) {
        changeTab(1)
      }
      updateInterestOptions()
      report({})
    }

    function stayTimeReport ({
      stay_time = 0,
      click = 0,
      hover = 0,
      sub_mode = (context.refs as any)?.payModule?.sub_mode || 0
    }) {
      let user_status = 0
      if (!user.isLogin) {
        user_status = 3
      } else if (user.isDiamondMember || user.isMember || user.isPdfLifeMember || user.isPdfMember || user.isVideoLifeMember || user.isVideoMember) {
        user_status = 1
      } else {
        user_status = 2
      }

      // 上报展示和操作
      client.home.REPORT.reportHomeOperate({
        main_click: click,
        main_hover: hover,
        sub_mode,
        user_login: user.isLogin ? 1 : 2,
        user_status,
        stay_time
      })
    }

    function closeReport () {
      client.home.REPORT.reportCenterStayTimeKfmt({
        show_page: STAY_PAGE_NUM[context.root.$route.name],
        user_login: user.loginStatus ? 1 : 2
      })
      report({ click: 7 })
    }

    function changeTab (index) {
      viewModel.curTab = index
      updateInterestOptions()
      report({ tab_click: index + 1 })
    }

    /** 更新权益组件选项 */
    function updateInterestOptions () {
      const classNames = ['item22', 'item23', 'item24', 'item25', 'item26', 'item27', 'item28', 'item29', 'item30', 'item31', 'item32', 'item33', 'item34', 'item35', 'item3']

      viewModel.interestOptions = {
        showAndPositionCards: classNames,
        hasDubaInterests: true,
        hasSpread: true,
        hasTitle: true
      }
      if (!isPdfTab.value) {
        viewModel.interestOptions = {
          showAndPositionCards: ['item36'],
          hasDubaInterests: false,
          hasSpread: false,
          hasTitle: false
        }
      }
    }

    function clickToTop () {
      const _parent = document.querySelector('.wrap_scroll')
      _parent.scrollTop = 0
    }

    function paySuccess () {
      user.refresh()
      // 购买成功重新刷新二维码 (逻辑废弃，组件内部已经实现)
      // payModule.value?.getQrCodeByServer()
    }

    function clickJoinVip () {
      changeTab(0)
    }

    function changePay (obj) {
      report({ hover: obj.idx })
    }

    function loginReport ({ idx }) {
      let i = 4
      if (idx && idx !== 9) { i = 13 }
      if (idx === 16) { i = 28 }

      report({ click: i })
    }

    function changeRenew (bool) {
      report({ click: bool ? 9 : 8 })
    }

    function toXieyi () {
      report({ click: 10 })
    }

    function changePayType (obj) {
      report({ click: obj.idx + 10 })
    }

    function report ({ click = 0, hover = 0, tab_click = 0 }) {
      const sub_mode = payModule.value?.sub_mode || 0
      client.home.REPORT.reportHomeOperate({
        main_click: click,
        main_hover: hover,
        sub_mode,
        tab_click,
        user_login: user.loginStatus ? 1 : 2
      })
    }
    return {
      ...toRefs(viewModel),
      payModule,
      isPdfTab,
      isMemberShip,
      closeReport,
      changeTab,
      clickToTop,
      paySuccess,
      clickJoinVip,
      changePay,
      loginReport,
      changeRenew,
      toXieyi,
      changePayType,
      blockRightButton () {
        return false
      },
    }
  },
})
